import Text from 'components/typography/text';
import Anchor from 'components/typography/anchor';
import { PetitionTypeList } from 'utilities/propTypes';

import getTargetTypeHumanName from 'utilities/targets';
import {
  petitionBase,
  petitionDetail,
  signatureCounts,
  signCount,
  signCountDetail,
  signCountPeriod,
  startedOn,
  subject,
} from './Petition.module.scss';

const trending = (sign_count_period) => {
  if (sign_count_period) {
    return (
      <div>
        <Text className={signCountPeriod}>
          {sign_count_period.toLocaleString()}
        </Text>
        <Text size="small" className={signCountDetail}>
          7d
        </Text>
      </div>
    );
  }
  return null;
};

const Petition = ({ petition }) => {
  const { state, target, petition_code } = petition;
  const hasState = !!state;
  const stateDetail = `(${state} only) `;
  const targetDetail = getTargetTypeHumanName(target);

  return (
    <div className={petitionBase}>
      <Anchor href={`/petitions/${petition_code}`}>
        <div className={petitionDetail}>
          <Text className={subject}>{petition.subject}</Text>

          <Text className={startedOn}>
            <em>to</em> {`${targetDetail} `}
            {hasState ? stateDetail : ''}
          </Text>
        </div>

        <div className={signatureCounts}>
          <div>
            <Text className={signCount}>
              {petition.sign_count.toLocaleString()}
            </Text>
            <Text size="small" className={signCountDetail}>
              Signers
            </Text>
          </div>
          {trending(petition?.trending?.sign_count_period)}
        </div>
      </Anchor>
    </div>
  );
};

Petition.propTypes = {
  petition: PetitionTypeList,
};

export default Petition;
